<template>
  <div>
    <area-chart
      :info-card="computedInfoCards"
      :data-series="computedSeries"
      :time-stamps="timeStamps"
      :format-percentage="true"
    />
  </div>
</template>

<script>
import AreaChart from '../widgets/BarChart.vue'

export default {
  components: { AreaChart },
  computed: {
    requestStats() {
      return this.$store.state.storageAnalytics.requestStats.stats ?? []
    },
    loadingRequestStats() {
      return this.$store.state.storageAnalytics.loadingRequestStats
    },
    peakComputed() {
      const data = this.computedSeries.map(x => x.data)[0]
      const peak = data.length !== 0 ? Math.max(...data) : 0
      const peakIndex = data.indexOf(peak)

      return {
        peak: peak.toLocaleString(),
        peakTime: (this.computedSeries.map(x => x.timestamps)[0])[peakIndex],
      }
    },
    totalComputed() {
      const data = this.computedSeries.map(x => x.data)[0]

      return data.reduce((accumulator, currentValue) => accumulator + currentValue, 0).toLocaleString()
    },
    computedInfoCards() {
      const infoCard = [
        {
          id: 1,
          title: 'Peak',
          description: `${this.peakComputed.peak} Requests`,
          loading: this.loadingRequestStats,
        },
        {
          id: 2,
          title: 'Peak Time',
          description: `${this.unixTimestampToDateTime(this.peakComputed.peakTime)}`,
          loading: this.loadingRequestStats,
        },
        {
          id: 3,
          title: 'Total Requests',
          description: `${this.totalComputed} Requests`,
          loading: this.loadingRequestStats,
        },
      ]
      return infoCard
    },
    computedSeries() {
      return this.getFormattedSeries(this.requestStats)
    },
    timeStamps() {
      if (this.requestStats && this.requestStats.length > 0) {
        return this.requestStats.map(x => x.timestamp)
      }

      return null
    },
  },
  methods: {
    getFormattedSeries(dataList) {
      const series = [{
        name: 'Requests',
        data: dataList?.map(item => item.value) || [],
        timestamps: dataList?.map(item => item.timestamp) || [],
      }]

      return series
    },
  },
}
</script>
